import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export type HomeSectionProps = {
  headingText: string;
  components: ReactNode[];
  actionText: string;
  actionFunction?: () => void;
  sectionClassName?: string;
  headingClassName?: string;
};

export function HomeSection(props: HomeSectionProps) {
  const {
    headingText,
    components,
    actionText,
    actionFunction,
    sectionClassName,
    headingClassName,
  } = props;

  return (
    <section className={twMerge('tw:mt-3', sectionClassName)}>
      <div className="tw:flex tw:items-center tw:justify-between tw:mb-3">
        <span
          className={twMerge('tw:text-xl tw:font-semibold tw:text-brand-green-0', headingClassName)}
        >
          {headingText}
        </span>
        {actionText && actionFunction ? (
          // TODO: make this a Button state
          <button
            className="tw:text-brand-green-1 tw:hover:text-brand-green-1/90 tw:text-sm tw:font-medium tw:bg-transparent tw:border-none tw:cursor-pointer"
            onClick={actionFunction}
          >
            {actionText}
          </button>
        ) : null}
      </div>
      <div>
        {components.map((node, index) => (
          <div key={index} className={index > 0 ? 'tw:mt-3' : undefined}>
            {node}
          </div>
        ))}
      </div>
    </section>
  );
}

export default HomeSection;
